<template>
  <div class="lwflgl" >

    <div style="width: 100%; height: 100%; display: flex; align-items: center; z-index: 5">
      <div style="width: 100%; height: 400px; display: flex; justify-content: center">
        <div style="display: flex; justify-content: space-around; width: 1200px; ">
          <div class="first" @click="toIndex">
             <div style="color: rgba(66,106,203,0.95); text-align: center; font-weight: bolder; font-size: 25px; padding: 65px; margin-top: 30px">Python中的参数传递与深浅拷贝</div>
          </div>
          <div class="second" @click="toBoot">
            <div style="color: rgba(66,106,203,0.95); text-align: center; font-weight: bolder; font-size: 25px; padding: 65px; margin-top: 30px">Python机器人模拟</div>
          </div>
          <div class="third" @click="toIndex03">
            <div style="color: rgba(66,106,203,0.95); text-align: center; font-weight: bolder; font-size: 25px; padding: 65px; margin-top: 30px">Python实战演练</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {qryPaperTypeList, updatePaperTypeInfo, delPaperTypeInfo} from '../../request/api';

  const encryptedUserIDArr = [
    'IL8UwUAspIaa4VTQUjnQGP6nx26Zx1JRk3HL5S/j1cM=',
    'LUJQyXlLfjh+fam9mqEIwU+U5JStay7TDI9DGJuO/Qw=',
    'oiKESIbwrQVogw1fm4LaGJ+EfRh7nU6GJqCJtKCoZHM=',
    'qSVlwg44NhPsQUMs3ycUbn1k9ojIJpWIYM5WnlsM7N4=',
    '04MsrJQsi/Cf3Q2d2RaH80DJGm/4GvbKB3CN4bEPzbM=',
    'YYedldY6xSB6NBtqQYMxGAI56rndXVDhREQjbdUPZKM=',
    'xthPjXiNWExdeux3UfDBHBjttSd8y8k+eCgRK2nhBds=',
    'SVuo4BrjK3OAnI0Z6yvXrSl9VFYpTwM1cH0zgfzt3R0=',
    'wIVEYo7ic6VqC5yN49FecwuDVml0b++fRUUBaRQNQQY=',
    'yANqISbDjxFtT7UMghbZKS6PcQzkuVR2QCbSpNeGD04=',
    'gAiycwkdYmf7d7YApkCLl1vpd6iZmtj2x8G0Wp5R2Fo=',
    'OHxlbnAJCZwDjKOQ7NYCBBduzWhcpOwullP4p+flyEg=',
    '3kWEtIvOggFVi7lq3pPDAU5O/9bYZJKfrEj1p5pufaQ=',
    'VDAEkYNtt5P9vZSiZjL3OiGZM21A9AKncZIzl1vzf30=',
    'H7amxyhqWlsMg6Dea4Ni/G2+HvsMbphcssnPlFE/tVM=',
    '1ZTHuTWZ56am9yyuLD6JxiVVR7ZySkgNI8LopAcJNek=',
    'soEnsk9z+V1yprfswYYCC+lVeGkz2TMX3nbvZanul/g=',
    'vaUciFgSQ6mjbgBjmluE/4XbKe68u87/Hbbbm2mNbh4=',
    'NzCDIuxErVNESr2Eg35q+I9IbkVnCBQQ/sEH1g6hxu8=',
    'wOXyV4znVr8Ed4MZzFqOybBjY3Pe1b7uIsK+SBmOuJg=',
    'rdG9cPD+Bqw3hoMLCSc31RawjhGnAhuWG6HHtABu6Hc=',
    '1rkIO8jKlxW/luL4n0l8P9evL8kk7s79MBDaNhLCXjo=',
    'WEykDQ7sOe2KRFyS3p6bgGFzzDOk449gNvqRABsZ074=',
    '3HjzP+SsimUrD2xo0vB6lq2ytJ8xBVw6y2mTKslZIv4=',
    '6VacHi01+XJM1tIKgGWq6cSNe3dglrmDoetyoVQf/wc=',
    'I5pRlH56nk9wgzjPqQnGsAaFtNKFVSj4jqiqGvxNtXE=',
    'tPbDltxyMmyfCW+DDT3rKmBQlZjQ1u02PuVxTBUmdxo=',
    'WanfNR1FmE+X4ryb1Q9D5yRoHO2LnDpFz1yJchm/hac=',
    'yVpzDVYH4zk9D1GoAp/e5vJwWguHuGYFp5bx9aaKWjE=',
    'RU+qmMavR2vPf7HD86Of+B8ZftEitG77WRvdOaDUMpo=',
    'uiT6LfhhW+qInWAxQkIjVSh6PnCoB1dxFyMWLfm4HxU=',
    'fVFDWgQmpyzkmZWs7S9n2s4HC9FdhzvyxXxtZuvkCy8=',
    '7Vgub3PsBdtHFsrrCXlPaKIZIA3jNZGHKdg9ABeSvNY=',
    'VGov4+9ii6rQquOcjJLOq1BVVka5WRth4xKc4VQ6FJM=',
    'NIsYMJCPbroz3yQgj+zRPMuXfDd+xJdWvhYQ0Spms1s=',
    '0YQUmZTfv9A4LTpcWmSgAT0BAD0T423g+s5K5necJWU=',
    'hkzBV/eporQDPyU1mzppV1KVt/D6L07RPF9wxg0spp8=',
    'M7z3NpneItdfOQ5vp3vfoXkv8fYVobZtIg4Ag1JunBU=',
    'egks1wVZHaLBD5FM/Kpqxz5MXNoEDXUgGeqYElq2130=',
    'H2lvXmf3NE6KyltsFRyGVKz+3Z1JmLiWJO5KY89pdrc=',
    'rbzqT/J70FIjr0q0VtDD6ZFWyHNEIEZLhgLQit8SXCk=',
    '3CCRlPrJy8KBwhGJFitMxGyDKtDFysxb66nRWIoqF78=',
    'OPko/e2yo2oBltgKzAAhbrfKXfuaV9/Op+pXpNhSXPE=',
    'Ohn8SoqhyT8dwg1mZFQalcmTXqvVPUs87zr3tjhWdKE=',
    'c9vADiX3TGJW3aAlAIngTweU8ucwEv5lci0ZBd/Mjrk=',
    'lt7rROwZLgyw3jNpDxFaER/U5lQLJCfcEnMjrhi+Msc=',
    'lT1qKJk8/2kXEZGtpjKocUPmmVtk9S8FSGn8am5MqrA=',
    'f0EFcwUppf0lV6hIcHTHyKlr+2HnbbgPkeSZCS4TMw8=',
    'KV4z1Ul3Jm6uE+rA1rwBY9XDJTMDRuvkiUoAPCEGnVM=',
    '6R538lCAc00wVbfooKQ/EBrsXJBHzBWnys79vwq9q5Y=',
  ]

  export default {
    data() {
      return {
        checkAll: false,
        tableData: [],
        search: '',
        updateForm: {
          id: '',
          typeName: '',
          createDate: ''
        },
        rules: {
          typeName: [
            {required: true, message: '分类名称不能为空', trigger: 'blur'},
            {max: 50, message: '长度小于50个字符', trigger: 'blur'}
          ]
        },
        searchForm: {
          typeName: "",
        },
        dialogFormVisible: false,
        formLabelWidth: '120px',
        robotUrl: window.__HEALTH_URL__.ROBOT_URI
      };
    },
    methods: {
      toIndex() {
        window.open(window.origin + "/#/onlyLw", '_blank')
      },
      toIndex03() {
        window.open(window.origin + "/#/onlyLw03", '_blank')
      },
      toBoot() {
        let userId = encryptedUserIDArr[Math.floor(Math.random() * encryptedUserIDArr.length)]
        window.open(this.robotUrl, '_target')
      },
      loadEbookTypeList() {
        let param = {
          typeName: this.searchForm.typeName
        }
        qryPaperTypeList(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.tableData = resp.data;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },

      handleAdd() {
        this.dialogFormVisible = true;
        this.updateForm.id = ''
        this.updateForm.typeName = ''
      },
      handleEdit(row) {
        this.dialogFormVisible = true;
        this.updateForm = row
      },
      handleDelete(row) {
        this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let param = {
            id: row.id
          }
          delPaperTypeInfo(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                // 渲染数据
                this.loadEbookTypeList();
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      onSubmit() {
        this.$refs['updateForm'].validate((valid) => {
          if (valid) {
            this.dialogFormVisible = false
            let param = this.updateForm;
            updatePaperTypeInfo(param).then(
              resp => {
                if (resp.code === 1) {
                  this.$message.success(resp.msg);
                  // 重置列表
                  this.loadEbookTypeList();
                } else {
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    mounted() {
      // 加载列表
      //this.loadEbookTypeList();
    },
    props: ["itemData"]
  };
</script>

<style lang="less" scoped>
  .lwflgl {
    height: calc(100vh - 50px);
    background-image: url("../../assets/startExp.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .el-table th.el-table__cell {
    background-color: #EFF3FF;
  }

  .searchClass {
    width: 900px;
    height: 70px;
    text-align: left;
    padding-left: 20px;
  }

  .searchClass .el-form-item__content {
    margin-top: 13px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
  }

  .upload-demo {
    text-align: left;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
  .background {
    border-radius: 1px;
    width: 100%;
    height: 100%;
    z-index:2;
    position: absolute;
  }

  .first {
    background-image: url("../../assets/first.png");
    width: 266px;
    height: 273px;
    cursor: pointer
  }
  .second {
    background-image: url("../../assets/second.png");
    width: 266px;
    height: 273px;
    cursor: pointer
  }
  .third {
    background-image: url("../../assets/third.png");
    width: 266px;
    height: 273px;
    cursor: pointer
  }

</style>




// WEBPACK FOOTER //
// src/components/lw/lwflgl.vue